module.exports = __webpack_public_path__ + "static/media/pin.b9bb3bef.svg";